module.exports = __webpack_public_path__ + "static/media/waveLogo.5b3efe4b.jpeg";